import React, { useState, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { muestrasContext } from '../Muestras';
import { useEffect } from 'react';

function ModalMuestra(props) {

    const { 
        user,
        idSubtask,
        setLoadingMuestra,
        fetchMuestrasById,
        setErrorMuestra,
        setMuestras,
        objMuestra,
        setObjMuestra
    } = useContext(muestrasContext)

    const [file, setFile] = useState("")

    const [errors, setErrors] = useState({})
    const [errorFetch, setErrorFetch] = useState(null)

    useEffect(() => {
        if(objMuestra){
            // Si es edición, no hacer nada por ahora
        }
    }, [objMuestra])

    const handleClose = () => {
        setErrors({})
        setErrorFetch(null)
        setFile("")
        setObjMuestra(null)
        props.onHide() 
    }

    const handleChangeFile = (e) => {
        setFile(e.target.files[0])
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        let errors = {}

        if (!file) {
            errors.evidencia = "Agregue un archivo válido.";
        }
        
        if (Object.keys(errors).length === 0){
            setErrors(null)

            const formData = new FormData()
            formData.append('idsubtarea', idSubtask)
            formData.append('tipo', 1)
            formData.append('user', JSON.stringify(user))
            formData.append('file', file)
            formData.append('titulo', file.name)

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/planAccion/addMuestra`, {
                    method: "POST",
                    body: formData
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0) {
                    setErrorFetch(data.errorDetalle || data.codeError)
                } else {
                    handleClose()
                    // actualizar muestras
                    fetchMuestrasById(idSubtask)
                    .then(res => {
                        if(res.error !== 0){
                            setLoadingMuestra(false)
                            setErrorMuestra(res.errorDetalle)
                        } else {
                            setLoadingMuestra(false)
                            setMuestras(res.objeto)
                        }
                    })
                }
            } catch (error) {
                setErrorFetch("Error: Conexión con backend.")
            }
        } else {
            setErrors(errors)
        }
    }

    const handleChangeMuestra = async (e) => {
        e.preventDefault()

        let errors = {}

        if (!file) {
            errors.evidencia = "Agregue un archivo válido.";
        }

        if (Object.keys(errors).length === 0){
            setErrors(null)

            const formData = new FormData()
            formData.append('user', JSON.stringify(user))
            formData.append('idMuestra', objMuestra?.id_muestra)
            formData.append('file', file)
            formData.append('titulo', file.name)
 
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/planAccion/modMuestra`, {
                    method: "PUT",
                    body: formData
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0) {
                    setErrorFetch(data.errorDetalle || data.codeError)
                } else {
                    handleClose()
                    // actualizar muestras
                    fetchMuestrasById(idSubtask)
                    .then(res => {
                        if(res.error !== 0){
                            setLoadingMuestra(false)
                            setErrorMuestra(res.errorDetalle)
                        } else {
                            setLoadingMuestra(false)
                            setMuestras(res.objeto)
                        }
                    })
                }
            } catch (error) {
                setErrorFetch("Error: Conexión con backend.")
            }
        } else {
            setErrors(errors)
        }
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__muestra'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    {objMuestra ? <h3 className='m-0'>Modificar archivo</h3>: <h3 className='m-0'>Adjuntar archivo</h3>}
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {objMuestra ? (
                    <div className='d-flex flex-column'>
                        <h4 className='text-blue-500'>Archivo anterior: <span className='text-dark fw-normal'>{objMuestra?.descripcion}</span></h4>
                        <form className='form__muestra d-flex flex-column align-items-center' onSubmit={handleChangeMuestra}>
                            <div className='w-100 mb-4'>
                                <input 
                                    type='file'
                                    onChange={handleChangeFile}
                                    className={`w-auto form-control rounded-pill border no-outline focus-ring ${
                                        errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                    }`}
                                />
                            </div>
                            {errors?.evidencia && (
                                <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errors?.evidencia}</span>
                            )}
                            {errorFetch !== null && (
                                <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errorFetch}</span>
                            )}
                            <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>Modificar archivo</button>
                        </form>
                    </div>
                ) : (
                    <form className='form__muestra d-flex flex-column align-items-center' onSubmit={handleSubmit}>
                        <div className='w-100 mb-4'>
                            <input 
                                type='file'
                                onChange={handleChangeFile}
                                className={`w-auto form-control rounded-pill border no-outline focus-ring ${
                                    errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                }`}
                            />
                        </div>
                        {errors?.evidencia && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errors?.evidencia}</span>
                        )}
                        {errorFetch !== null && (
                            <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errorFetch}</span>
                        )}
                        <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>+ adjuntar archivo</button>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default ModalMuestra